import ACTIONS from '../actionTypes/organization'

const initialState = {
	organization: null,
	isFetchingCurrentOrg: false,
	isCreatingOrg: false,
	orgList: [],
	isFetchingOrgList: false,
	errorFetchingOrgList: false,
	isUpdatingOrg: false,
	errorUpdatingOrg: false
}

const organization = (state = initialState, action) => {
	switch (action.type) {
		// createOrganization
		case ACTIONS.START_CREATE_ORG:
			return {
				...state,
				isCreatingOrg: true,
			}
		case ACTIONS.CREATE_ORG_SUCCESS:
			return {
				...state,
				isCreatingOrg: false,
				organization: action.payload,
			}
		case ACTIONS.CREATE_ORG_FAILED:
			return {
				...state,
				isCreatingOrg: false,
				organization: null,
			}

		// getOrganizationList
		case ACTIONS.START_GET_ORG_LIST:
			return {
				...state,
				isFetchingOrgList: true,
			}
		case ACTIONS.GET_ORG_LIST_SUCCESS:
			return {
				...state,
				isFetchingOrgList: false,
				errorFetchingOrgList: false,
				orgList: action.payload,
			}
		case ACTIONS.GET_ORG_LIST_FAILED:
			return {
				...state,
				isFetchingOrgList: false,
				errorFetchingOrgList: true,
				orgList: null,
			}

		// getOrganizationById
		case ACTIONS.START_GET_ORG_BY_ID:
			return {
				...state,
				isFetchingCurrentOrg: true
			}
		case ACTIONS.GET_ORG_BY_ID_SUCCESS:
			return {
				...state,
				isFetchingCurrentOrg: false,
				organization: action.payload,
			}
		case ACTIONS.GET_ORG_BY_ID_FAILED:
			return {
				...state,
				isFetchingCurrentOrg: false,
				organization: null,
			}

		// updateOrganization
		case ACTIONS.START_UPDATE_ORG:
			return {
				...state,
				isUpdatingOrg: true
			}
		case ACTIONS.UPDATE_ORG_SUCCESS:
			return {
				...state,
				isUpdatingOrg: false,
				errorUpdatingOrg: false,
				organization: action.payload,
			}
		case ACTIONS.UPDATE_ORG_FAILED:
			return {
				...state,
				isUpdatingOrg: false,
				errorUpdatingOrg: true
			}

		// default
		default:
			return state
	}
}

export default organization